import { AxiosResponse } from 'axios';
import { SelectedShop } from 'models';
import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchShopListAPI } from 'redux/api/shopApi';
import { shopListAction } from 'slices/shopSlice';

function* fetchShopListSaga(action: any) {
  const { token } = action.payload;

  try {
    const res: AxiosResponse = yield call(fetchShopListAPI, token);
    const { data } = res.data;

    yield put(shopListAction.fetchShopListSuccess(data));
  } catch (error) {
    console.log('fetch shop list error: ', error);
    yield put(shopListAction.fetchShopListFailed());
  }
}
export default function* shopSaga() {
  yield takeEvery(shopListAction.fetchShopList.type, fetchShopListSaga);
}
